import { Injectable } from '@angular/core';

interface IScriptTracker {
	key: string;
	element: HTMLElement;
	type: 'js' | 'css';
}

@Injectable()
export class ScriptLoaderService {
	private _tracker: IScriptTracker[] = [];

	loadJS(scriptUrl: string, key: string = null): Promise<HTMLScriptElement> {
		return new Promise((resolve) => {
			/** create the element */
			const scriptEl: HTMLScriptElement = document.createElement('script');
			scriptEl.type = 'text/javascript';
			scriptEl.async = true;
			scriptEl.src = scriptUrl;
			scriptEl.addEventListener('load', (ev: Event) => {
				this._tracker.push({
					key: key || scriptUrl,
					element: scriptEl,
					type: 'js'
				});
				resolve(scriptEl);
			});

			/** inject the script into the page */
			document.body.appendChild(scriptEl);
		});
	}

	/** load a css file */
	loadCSS(styleUrl, key: string = null): Promise<HTMLLinkElement> {
		return new Promise((resolve) => {
			/** create the element */
			const styleEl: HTMLLinkElement = document.createElement('link');
			styleEl.type = 'text/css';
			styleEl.rel = 'stylesheet';
			styleEl.href = styleUrl;
			styleEl.addEventListener('load', (ev: Event) => {
				this._tracker.push({
					key: key || styleUrl,
					element: styleEl,
					type: 'css'
				});
				resolve(styleEl);
			});

			/** inject the styles into the page */
			document.head.appendChild(styleUrl);
		});
	}

	unload(el: HTMLElement): void {
		if (el.tagName.toLowerCase() === 'script') document.body.removeChild(el);
		if (el.tagName.toLowerCase() === 'link') document.head.removeChild(el);
		el = null;
	}

	removeElement(key: string, type: string): void {
		const tracker: IScriptTracker = this._tracker.find((t) => t.key === key && t.type === type);
		if (tracker) {
			this.unload(tracker.element);
			this._tracker.remove((t) => t.key === key && t.type === type);
		}
	}

	getElement(key: string, type: string): IScriptTracker {
		return this._tracker.find((t) => t.key === key && t.type === type);
	}
}
